export const adapter = { browserDetails: { browser: 'ReactNative', version: 0 } };

export const sdkVersion = '__package_version__';

export const isBrowser = false;
export const isNodeJS = false;
export const isReactNative = true;
export const isExpo = typeof (globalThis as typeof globalThis & { Expo?: unknown }).Expo !== 'undefined';


try {
  const { registerGlobals } = require('react-native-webrtc');
  registerGlobals();
} catch (error) {
  console.warn('[react-native-webrtc] Failed to register globals:', error);
}

export const {
  navigator,
  MediaStream,
  MediaStreamTrack,
  RTCIceCandidate,
  RTCPeerConnection,
  RTCRtpReceiver,
  RTCRtpSender,
  RTCSessionDescription,
} = globalThis;
export const { mediaDevices } = navigator || {};
export const isWebRTCAvailable = Boolean(mediaDevices && RTCPeerConnection);
